import { Conflict } from '../types';
import { useTranslation } from 'react-i18next';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { Avatar } from '@components/avatar';
import { parseRoute } from '@utils/i18n';
import { Link } from 'react-router';
import { appRoutes } from '@utils/consts';
import { formatConflictTimeRange } from './helpers';

export const PublishScheduleConfirmationCrewBox = ({
  crewConflicts,
  skipWarning = false,
}: {
  crewConflicts: Conflict[];
  skipWarning?: boolean;
}) => {
  const { t } = useTranslation('app', { keyPrefix: 'publisher.conflicts' });

  const crewDetails = crewConflicts[0];

  return (
    <div className="border border-light-400 p-1 rounded-md gap-2 mb-2">
      <div className="flex relative flex-col w-full h-full gap-1">
        <div className="flex h-full w-full items-center gap-2 pb-2">
          <Avatar name={crewDetails.fullName} />
          <div className="flex flex-col truncate">
            <span className="w-fit flex-none text-xs font-normal">{crewDetails.fullName}</span>
            {crewDetails.extraName && (
              <span
                className="truncate text-[10px] leading-3 text-neutral-400"
                title={crewDetails.extraName}>
                {crewDetails.extraName}
              </span>
            )}
          </div>
          {!skipWarning && (
            <div className="flex-1 text-right pr-2">
              <span className="bg-red-50 rounded-md px-2.5 py-0.5 text-xs font-normal text-red-800">
                {t('warning', { count: crewConflicts.length })}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col p-2">
        {crewConflicts.map((conflict) => (
          <div key={conflict.scheduleId} className="flex items-center gap-2">
            <span className="flex-3 text-sm font-semibold text-green-600">{conflict.name}</span>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to={`/${parseRoute(
                appRoutes.jobWorkProgress(conflict.projectId, conflict.jobId),
              )}${conflict.stageId ? `?open=${conflict.stageId}&focus=${conflict.stageId}` : ''}`}>
              <span className="flex-1 text-left">
                <SvgConsumer id="eye" className="text-neutral-400" />
              </span>
            </Link>
            <span className="flex-1 text-xs text-right pr-2 font-normal text-neutral-400">
              {formatConflictTimeRange(conflict.startsAt, conflict.endsAt)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
